import { BrowserRouter, Routes, Route } from "react-router-dom";
import Dashboard from "@/pages/Dashboard";
import AccessGate from "@/components/AccessGate";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";

export default function App() {
  return (
    <div className="App min-h-screen bg-[var(--bg-base)] text-[var(--text)]">
      <AccessGate>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Dashboard />} />
          </Routes>
        </BrowserRouter>
      </AccessGate>
      <Toaster theme="dark" position="bottom-right" />
    </div>
  );
}
